import { ChangeDetectionStrategy, ChangeDetectorRef, Component, forwardRef, Inject, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { IUnsecuredService, IUnsecuredStatus } from '../../../services/unsecured/unsecured-service.interface';
import { Observable } from 'rxjs';
import { EventsServiceInterface } from '../../../services/events/events.interface';

@Component({
  selector: 'gtd-protected-form',
  templateUrl: './protected-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ProtectedFormComponent),
      multi: true,
    },
  ],
})
export class ProtectedFormComponent implements OnInit, ControlValueAccessor {
  @Input() format: 'text' | 'number' | 'datepicker' | 'email' | 'money' | 'boolean';
  @Input() label: string;

  public unsecuredStatus$: Observable<IUnsecuredStatus>;
  public control: FormControl;
  public onChange: (value: any) => void = () => {};

  public onTouch = () => {};

  public afterClosed = () => {
    this.eventsService.broadcast('2fa:afterClosed');
  };

  constructor(
    @Inject('IUnsecuredService') public unsecuredService: IUnsecuredService,
    private cdr: ChangeDetectorRef,
    @Inject('EventsServiceInterface') protected eventsService: EventsServiceInterface
  ) {}

  public ngOnInit(): void {
    this.control = new FormControl();
    this.unsecuredStatus$ = this.unsecuredService.getUnsecuredStatus();
    this.control.valueChanges.subscribe((value) => {
      this.onChange(value);
    });
  }

  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  public writeValue(value: any): void {
    this.control.setValue(value, { emitEvent: false });
    this.cdr.markForCheck();
  }
}
